import { IResourceComponentsProps } from '@pankod/refine-core'
import { PapersTableList } from 'components/papers'

export const PapersList: React.FC<IResourceComponentsProps> = () => {
  return (
    <>
      <PapersTableList />
    </>
  )
}
